<template>
  <div>
    <el-card>
      <div class="topDiv">
        <el-input v-model="params.projectName" placeholder="请输入"></el-input>
        <el-button type="primary" size="medium" class="demo-input-label" icon="el-icon-search" @click="searchClick">搜索</el-button>
        <el-button type="primary" size="medium" class="demo-input-label" icon="el-icon-plus" @click="addInfoClick()">添加</el-button>
      </div>
    </el-card>
    <div>
      <el-table :data="records" border style="width: 98%" :height="innerHeight">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="projectName" label="活动名称" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="tenantName" label="公司名称" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="status" label="状态" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              {{ scope.row.status | ziHuoDongStatus }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button type="warning" v-if="scope.row.status == 2" size="mini" @click="updateStatus(scope.row)">下架</el-button>
            <el-button type="primary" v-else size="mini" @click="updateStatus(scope.row)">上架</el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="updateClick(scope.row)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteClick(scope.row)">删除</el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="ziHuoDongClick(scope.row)">子活动列表</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <pagination :pagingParams="params" :total="total" @pagingSizeChange="handleSizeChange" @pagingNumChange="handleCurrentChange"></pagination>
    </div>

    <!--  新增活动/ 修改活动-->
    <el-dialog :title="rowData ? '修改活动' : '新增活动'" :visible.sync="huoDongDia" v-if="huoDongDia" width="600px" @close="huoDongDia = false">
      <huoDongDia :rowData="rowData" @quXiaoClick="huoDongDia = false" @diaQueDingClick="diaQueDingClick"></huoDongDia>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/components/common/pagination/Index.vue'
import { commonMixin } from '@/utils/mixin/index.js'
import huoDongDia from '@/components/huoDongDia.vue'
import { saveDataToLocalStorage } from '@/utils/tools.js'

export default {
  components: { pagination, huoDongDia },
  mixins: [commonMixin],
  data() {
    return {
      huoDongDia: false,
      params: {
        projectName: '',
        pageNum: 1,
        pageSize: 10,
      },
      records: [],
      total: 0,
      rowData: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    searchClick() {
      this.params.pageNum = 1
      this.getData()
    },
    //
    async getData() {
      const res = await this.$API.huoDong.getHuoDongList(this.params)
      if (res.status !== 200) return this.$message.error(res.msg)
      const { records, total } = res.data
      this.records = records
      this.total = +total
    },
    // 子活动列表
    ziHuoDongClick(row) {
      saveDataToLocalStorage('huoDongRow', row, true)
      // this.$router.push('/huoDongManage/ziHuoDongList')
      this.$router.push({ path: '/huoDongManage/ziHuoDongList?id=' + row.id + '&tenantName=' + row.tenantName })
    },
    // 添加
    addInfoClick() {
      this.rowData = ''
      this.huoDongDia = true
    },
    // 编辑
    updateClick(item) {
      this.huoDongDia = true
      this.rowData = item
    },
    // 弹框上 确定 click
    async diaQueDingClick() {
      this.huoDongDia = false
      this.getData()
    },
    //  删除
    async deleteClick(row) {
      this.$confirm('确定删除活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async (res) => {
        if (res == 'confirm') {
          const params = {
            id: row.id,
            tenantName: row.tenantName,
          }
          const res = await this.$API.huoDong.delete(params)
          if (res.status !== 200) return this.$message.error(res.msg)
          this.$message.success(res.data)
          this.params.pageNum = 1
          this.getData()
        }
      })
    },
    updateStatus(item) {
      let t = ''
      let status = ''
      if (item.status == 2) {
        t = '下架'
        status = 3
      } else {
        t = '上架'
        status = 2
      }
      this.$confirm('确定[' + t + ']活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async (res) => {
        if (res == 'confirm') {
          let result = await this.$API.huoDong.updateStatus({ id: item.id, status, tenantName: item.tenantName })
          if (result.status !== 200) return this.$message.error(result.msg)
          this.$message.success(result.data)
          this.params.pageNum = 1
          this.getData()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.topDiv {
  display: flex;
  .el-input {
    width: 200px;
    margin-right: 20px;
  }
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.el-breadcrumb {
  margin-bottom: 20px;
}
.demo-input-label {
  display: inline-block;
  width: 130px;
  margin-right: 10px;
  margin-left: 0;
}
::v-deep.el-tree-node {
  .is-leaf + .el-checkbox .el-checkbox__inner {
    display: inline-block;
  }
  .el-checkbox .el-checkbox__inner {
    display: none;
  }
}
.el-pagination {
  width: 1000px;
  margin: 20px auto;
}
.el-tag {
  margin: 7px;
}
</style>
